import styled from 'styled-components'

export const IconPlaceholder = styled.div<{ width: string; height: string }>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`
